import React, { useContext, useState } from "react";
import { Modal, Select } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { FacilityID, IS_HOD, Role } from "../../../constants/defaultKeys";
import { UserContext } from "../../../context/UserContext";
import { getCookie, setCookie } from "../../../helpers/localStorage";
import { redirectToDashboard } from "../../../helpers/auth/helper";
import { getRoleLabelWithFacility } from "../../../helpers/getRoleLabel";
import useIsMobile from "../../../hooks/useIsMobile";

const { Option } = Select;

const SwitchRole = () => {
  const { userDetails, setUserDetails } = useContext(UserContext);
  const params = useParams();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [visible, setVisible] = useState(params?.tab === "true" && true);
  const [selectedRole, setSelectedRole] = useState(
    getCookie(Role) || userDetails?.activeOrg?.roles?.[0]?.role
  );
  const [selectedFacility, setSelectedFacility] = useState(
    Number(getCookie(FacilityID)) || userDetails?.currFacility
  );

  const handleRoleChange = (value) => {
    const lastUnderscoreIndex = value.lastIndexOf("_");

    // Extract role by slicing up to the last underscore
    const role = value.slice(0, lastUnderscoreIndex);

    // Extract facility ID by slicing after the last underscore
    const facility_id = value.slice(lastUnderscoreIndex + 1);

    const is_hod = userDetails?.activeOrg?.roles?.find(
      (record) =>
        record?.role === role && record?.facility_id === Number(facility_id)
    )?.is_hod;
    const roleObj = userDetails?.activeOrg?.roles?.find(
      (record) =>
        record.role === role && record.facility_id === Number(facility_id)
    );

    redirectToDashboard(userDetails?.activeOrg?.domain, role, roleObj);
    setSelectedRole(value);
    setSelectedFacility(facility_id);
    setCookie(Role, role, `.${process.env.REACT_APP_PUBLIC_DOMAIN}`, "/");
    setCookie(IS_HOD, is_hod, `.${process.env.REACT_APP_PUBLIC_DOMAIN}`, "/");
    setCookie(
      FacilityID,
      facility_id,
      `.${process.env.REACT_APP_PUBLIC_DOMAIN}`,
      "/"
    );
    setUserDetails((prev) => ({
      ...prev,
      currRole: role,
      currFacility: facility_id,
    }));
  };

  return (
    <Modal
      open={visible}
      footer={null}
      onCancel={() => {
        setVisible(false);
        navigate(-1);
      }}
      width={isMobile ? "calc(100vw - 32px)" : 520}
      className="switch-role-modal"
      styles={
        isMobile
          ? {
              body: { padding: "16px 12px" },
            }
          : undefined
      }
    >
      <Select
        value={`${selectedRole}_${selectedFacility}`}
        onChange={handleRoleChange}
        className="switch-role-select"
        style={{ width: isMobile ? "100%" : 350 }}
        popupMatchSelectWidth
      >
        {userDetails?.activeOrg?.roles?.map(
          (role) =>
            role?.role !== "Partner" && (
              <Option
                value={`${role?.role}_${role?.facility_id}`}
                key={`${role?.role}_${role?.facility_id}`}
              >
                {getRoleLabelWithFacility(role)}
              </Option>
            )
        )}
      </Select>
    </Modal>
  );
};

export default SwitchRole;
